module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('van-cell-group', [(false) ? _c('van-field', {
    attrs: {
      "value": _vm.row.name,
      "label": "用户名",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    },
    on: {
      "click": _vm.toSetUserName
    }
  }) : _vm._e(), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'UserPassword'
      }),
      expression: "{name:'UserPassword'}"
    }],
    attrs: {
      "label": "登录密码",
      "value": "*******",
      "input-align": "right",
      "is-link": "",
      "readonly": ""
    }
  }), _vm._v(" "), (false) ? _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "支付密码",
      "value": "*******",
      "is-link": "",
      "readonly": ""
    },
    on: {
      "click": _vm.toSetPayPassWord
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "绑定手机",
      "placeholder": "更换手机",
      "is-link": "",
      "readonly": ""
    },
    on: {
      "click": _vm.toSetPhone
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n            绑定手机\n            "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "van-fields"
  }, [_vm._v(_vm._s(_vm.row.phone))])])]) : _vm._e(), _vm._v(" "), (false) ? _c('van-field', {
    attrs: {
      "input-align": "right",
      "is-link": "",
      "readonly": ""
    },
    on: {
      "click": _vm.toAccount
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n            余额\n            "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "van-fields"
  }, [_vm._v(_vm._s(_vm.row.balance / 100))])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a480825","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/setting/Setting.vue
// module id = 1427
// module chunks = 0